<template>
  <div>
    <div class="row">
      <div class="col-8">
        <form class="md-layout" @submit.prevent="() => {}">
          <div class="md-layout-item">
            <md-card-header>
              <div class="md-title">
                {{ cargoId ? 'Editar' : 'Cadastrar' }} Cargo
              </div>
            </md-card-header>
            <md-card-content>
              <md-field :class="getValidationClass('titulo')">
                <label for="titulo">Nome do cargo</label>
                <md-input id="titulo" v-model="form.titulo" />
                <span v-if="!$v.form.titulo.required" class="md-error"
                  >Nome do cargo é obrigatório</span
                >
              </md-field>
              <div class="botoes">
                <md-button
                  class="md-raised md-accent"
                  @click="() => $router.back()"
                >
                  Voltar
                </md-button>
                <md-button class="md-raised md-primary" @click="salvar">
                  Salvar
                </md-button>
              </div>
            </md-card-content>
          </div>
        </form>
      </div>
      <div class="col-4">
        <md-card class="md-layout-item">
          <md-card-header>
            <div class="md-title">Pessoas</div>
          </md-card-header>
          <md-card-content>
            <div class="md-layout md-gutter">
              <div class="md-layout-item md-size-75">
                <md-autocomplete
                  v-model="pessoaSelected"
                  :md-options="pessoasSearch"
                >
                  <label>Buscar pessoa</label>
                </md-autocomplete>
              </div>
              <div class="md-layout-item" style="text-align: right">
                <md-button
                  class="md-raised md-primary"
                  @click="adicionarPessoasSelected"
                >
                  Adicionar
                </md-button>
              </div>
            </div>
          </md-card-content>

          <md-list class="md-double-line">
            <md-list-item v-for="pessoa in pessoasSelected" :key="pessoa.id">
              <div class="md-list-item-text">
                <span>{{ pessoa.nomeCompleto }}</span>
              </div>
              <md-button
                class="md-icon-button md-list-action"
                @click="() => removePessoaSelected(pessoa)"
              >
                <md-icon class="md-primary"> delete </md-icon>
              </md-button>
            </md-list-item>
          </md-list>
        </md-card>
      </div>
    </div>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'

import http from '../../utils/http'

export default {
  name: 'CargoInput',
  mixins: [validationMixin],
  data() {
    return {
      localId: null,
      cargoId: null,
      form: {
        titulo: null,
      },
      pessoas: [],
      // Form pessoa
      pessoasSearch: [],
      pessoaSelected: '',
      pessoasSelected: [],
    }
  },
  validations() {
    const rules = {
      form: {
        titulo: { required },
      },
    }

    return rules
  },
  async beforeMount() {
    this.localId = this.$route.params.localId
    this.cargoId = this.$route.params.cargoId

    if (this.cargoId) {
      const cargo = (await http.get(`cargo/${this.cargoId}`)).cargo

      this.form = {
        ...this.form,
        ...cargo,
      }

      this.pessoasSelected = cargo.users.map((e) => ({
        ...e,
        nomeCompleto: e.fullName,
      }))
    }
  },
  mounted() {
    this.fetchPessoas()
  },
  methods: {
    async removePessoaSelected(pessoa) {
      if (this.cargoId) {
        await http.delete(
          `local/${this.localId}/cargo/usuario`,
          pessoa.cargoUserId
        )
      }

      this.pessoasSelected = this.pessoasSelected.filter(
        (p) => p.id !== pessoa.id
      )
    },
    async adicionarPessoasSelected() {
      const user = this.pessoas.find((e) => e.userName === this.pessoaSelected)

      if (this.cargoId) {
        await http.post(`local/${this.localId}/cargo/usuario`, {
          cargoId: this.cargoId,
          userId: user.id,
        })
      }

      if (!user) {
        return
      }

      if (
        this.pessoasSelected.some((e) => e.userName === this.pessoaSelected)
      ) {
        return
      }

      this.pessoasSelected.push(user)

      this.pessoaSelected = ''
    },
    async fetchPessoas() {
      this.pessoas = (await http.get(`local/${this.localId}/usuarios`)).users

      this.pessoasSearch = this.pessoas.map((pessoa) => pessoa.userName)
    },
    async salvar() {
      this.$v.$touch()

      let result = null

      if (this.cargoId) {
        if (this.$v.form.titulo.$invalid) {
          return
        }

        result = await http.put('cargo', {
          cargoId: this.cargoId,
          ...this.form,
        })
      } else {
        // Cadastrar
        if (this.$v.$invalid) {
          return
        }

        result = await http.post('cargo', {
          ...this.form,
          localId: this.localId,
        })

        const promisesPessoa = this.pessoasSelected.map((pessoa) => {
          const pessoaId = this.pessoas.find(
            (e) => e.userName === pessoa.userName
          ).id

          return http.post(
            `local/${this.localId}/cargo/usuario`,
            {
              cargoId: result,
              userId: pessoaId,
            },
            false
          )
        })

        await Promise.all(promisesPessoa)
      }

      if (result != null) {
        await this.$router.back()
      }
    },
    getValidationClass(fieldName) {
      const field = this.$v.form[fieldName]

      if (field) {
        return {
          'md-invalid': field.$invalid && field.$dirty,
        }
      }
    },
  },
}
</script>

<style scoped>
div > .md-card {
  height: 100%;
  overflow: auto;
  max-height: 90vh;
}

form {
  height: 90vh;
}

.botoes {
  float: right;
}
</style>
